// Pallavit tier plans + add-ons

export const PLANS = [
  {
    key: 'sapling',
    name: 'Pallavit Sapling',
    tagline: 'A beginning, gently rooted.',
    price: 999,
    duration: '',
    for: 'Students, young professionals, eco-lovers',
    includes: [
      'Sapling planted in their name',
      'Digital certificate of dedication',
      'Quarterly updates for 1 year',
    ],
    icon: '🌱',
    accent: '#8FA978',
  },
  {
    key: 'care',
    name: 'Pallavit Care',
    tagline: 'Three years of quiet tending.',
    price: 2999,
    duration: '',
    for: 'Those who want to contribute, not maintain forever',
    includes: [
      'Fruit tree planted in their name',
      'Wooden name plaque',
      'Physical certificate delivered to your home',
      '3 years of seasonal updates',
    ],
    icon: '🌿',
    accent: '#6B8E5A',
  },
  {
    key: 'lifetime',
    name: 'Pallavit Lifetime Tree',
    tagline: 'A tree that gives back over time.',
    price: 9999,
    duration: '15–20 years',
    includes: [
      'Fruit tree planted in their name',
      'Wooden name plaque',
      'Framed certificate with plantation memory',
      'Annual fruit box',
      'Valid for 15–20 years',
    ],
    note: 'Fruit sharing depends on natural cycles and seasonal yield.',
    icon: '🌳',
    accent: '#2D4A32',
    featured: true,
  },
  {
    key: 'family',
    name: 'Pallavit Family Grove',
    tagline: 'For families, legacies, and deeper connections.',
    price: 24999,
    duration: 'Lifetime',
    includes: [
      '3 trees in family name',
      'GPS tracking for all trees',
      'Personalized video updates',
      'Annual visit experience',
      'Fruit deliveries',
    ],
    note: 'Fruit sharing depends on natural cycles and seasonal yield.',
    icon: '🍎',
    accent: '#C69C6D',
  },
];

// Add-ons are offered inside the checkout dialog, not on the marketing page.
export const ADDONS = [
  {
    key: 'birthday',
    name: 'Gift a Tree on Birthday',
    price: 499,
    copy: 'Add a birthday note & video message to their tree page.',
  },
  {
    key: 'family',
    name: 'Family Tree',
    price: 1999,
    copy: 'Plant 5 saplings together with one shared name-board.',
  },
  {
    key: 'visit',
    name: 'Tree Visit Day Pass',
    price: 999,
    unit: 'per person',
    copy: 'Visit the orchard, see your tree, join a plantation.',
  },
];

export const getPlan = (key) => PLANS.find((p) => p.key === key) || PLANS[2];
export const getAddon = (key) => ADDONS.find((a) => a.key === key);

export const formatINR = (n) =>
  '₹' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
